'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cart;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Cart(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-cart ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M14.666 9.36a.649.649 0 0 1-.639.529H5.89l.166.889h7.472c.204 0 .37.083.5.25.13.166.176.351.14.555l-.167.695c.277.13.495.319.652.569.158.25.237.523.237.82 0 .425-.153.791-.459 1.097a1.497 1.497 0 0 1-1.097.458c-.426 0-.792-.153-1.097-.458a1.513 1.513 0 0 1-.459-1.112c0-.435.158-.8.473-1.097H6.417c.314.297.472.662.472 1.097 0 .436-.153.806-.459 1.112a1.497 1.497 0 0 1-1.097.458c-.426 0-.791-.153-1.097-.458a1.497 1.497 0 0 1-.458-1.098c0-.277.07-.537.208-.777.139-.241.329-.436.57-.584L2.61 2.778H.667a.643.643 0 0 1-.473-.195A.643.643 0 0 1 0 2.111v-.444c0-.186.065-.343.194-.473A.643.643 0 0 1 .667 1h2.86c.149 0 .283.05.403.153.12.102.2.227.237.375l.25 1.25h10.916c.222 0 .398.083.528.25.13.166.166.352.11.555l-1.305 5.778z' })
  );
}

Cart.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Cart/Cart.js
// module id = 1140
// module chunks = 1